import React from 'react';
import { render } from '@testing-library/react';
import { FilePicker } from './FilePicker';

describe('FilePicker', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<FilePicker
				accept="image/*, text/.txt"
				value={null}
				onSelected={jest.fn()}
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
